import {TypeString} from './../TypeDefinition'

import ParseExpression from './ParseExpression.js'
import CodeHelpers from './CodeHelpers.js'

function ParseIO (parser) {
    this.parser = parser
    this.scanner = parser.scanner
    this.pcode = parser.pcode
    this.stable = parser.stable
    this.SC = parser.config
}

ParseIO.prototype = {
    parseRead () {
        let ident
        let token
        let readIdent = true
        let resultType
        let parseExpression = new ParseExpression(this.parser)
        let codeHelpers = new CodeHelpers(this.parser)

        ident = this.parser.expect(this.SC.K_READ)
        if (ident === false) {
            this.parser.error(ident, 'Se esperaba Leer.')
        }

        while (readIdent) {
            ident = this.parser.expect(this.SC.IDENT)
            if (ident !== false) {
                if (!this.stable.hasStorage(ident.lexema)) {
                    this.parser.error(ident, 'Variable ' + ident.lexema + ' no definida.')
                } else if (this.stable.hasParameter(ident.lexema) && !this.stable.getParameter(ident.lexema).getType().isReference()) {
                    this.parser.error(ident, 'No se puede leer en el parámetro ' + ident.lexema + ' ya que se ha pasado por valor.')
                } else {
                    if (this.stable.getStorage(ident.lexema).getType().isArray()) {
                        token = this.parser.expect(this.SC.INDEX_SEL_OPEN)
                        if (token === false) {
                            this.parser.error(ident, 'La variable ' + ident.lexema + ' es un arreglo, se esperaba apertura de corchetes.')
                        }

                        token = this.scanner.next()

                        resultType = parseExpression.parse()

                        if (!resultType.isInt()) {
                            this.parser.error(token, 'La expresión para acceder al arreglo debe ser de tipo entera.')
                        }

                        this.parser.expect(this.SC.INDEX_SEL_CLOSE)
                    }
                }

                if (this.parser.compile) {
                    this.pcode.read(this.stable.getStorage(ident.lexema).getType(), ident)
                    codeHelpers.codeStoreVar(ident)
                }
            }
            if (this.scanner.nextIs(this.SC.COMMA)) {
                this.scanner.consume()
            } else {
                readIdent = false
            }
        }

        this.parser.expect(this.SC.SEMICOLON)
    },
    parseWrite () {
        let tokenStartExp
        let resultType
        let tokenWrite
        let jump = true
        let parseExpression = new ParseExpression(this.parser)

        tokenWrite = this.parser.expect(this.SC.K_WRITE)
        if (tokenWrite === false) {
            this.parser.error(tokenWrite, 'Se esperaba Escribir.')
        }

        if (this.scanner.nextIs(this.SC.K_WITHOUT_JUMP)) {
            this.scanner.consume()
            jump = false
        }

        tokenStartExp = this.scanner.next()
        resultType = parseExpression.parse()

        if (resultType.isError()) {
            this.parser.error(tokenStartExp, 'Error en la expresión para escribir.')
        } else if (this.parser.compile) {
            this.pcode.write(tokenWrite)
        }

        while (this.scanner.nextIs(this.SC.COMMA)) {
            this.scanner.consume()

            tokenStartExp = this.scanner.next()
            resultType = parseExpression.parse()

            if (resultType.isError()) {
                this.parser.error(tokenStartExp, 'Error en la expresión para escribir.')
            } else if (this.parser.compile) {
                this.pcode.write(tokenWrite)
            }
        }

        if (jump && this.parser.compile) {
            this.pcode.ldcons(TypeString(), '\n', tokenWrite)
            this.pcode.write(this.scanner.next())
        }

        this.parser.expect(this.SC.SEMICOLON)
    },
    parseWait () {
        let expType
        let nextToken
        let parseExpression = new ParseExpression(this.parser)

        this.parser.expect(this.SC.K_WAIT)

        if (this.scanner.nextIs(this.SC.K_KEY)) {
            nextToken = this.parser.expect(this.SC.K_KEY)
            if (this.parser.compile) {
                this.pcode.waitKey(nextToken)
            }
        } else {
            nextToken = this.scanner.next()
            expType = parseExpression.parse()

            if (!expType.isInt()) {
                this.parser.error(nextToken, 'La expresión para la sentencia Esperar debe ser de tipo Entero.')
            }

            if (this.parser.compile) {
                this.pcode.waitTime(nextToken)
            }
        }

        this.parser.expect(this.SC.SEMICOLON)
    },
    parseClearScreen () {
        let clearToken = this.parser.expect(this.SC.K_CLEAR_SCREEN)

        if (this.parser.compile) {
            this.pcode.clearScreen(clearToken)
        }

        if (this.scanner.nextIs(this.SC.OPEN_PAR)) {
            this.parser.expect(this.SC.OPEN_PAR)
            this.parser.expect(this.SC.CLOSE_PAR)
        }
        this.parser.expect(this.SC.SEMICOLON)
    }
}

export default ParseIO



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseIO.js